import { ExclamationCircleFilled } from "@ant-design/icons";
/**
 * Component to manage role and show message
 */
export const Role = () => {
  return (
    <div className="centerPage">
      <div className="divAlignCenter">
        <ExclamationCircleFilled className="iconCss" />
        <p> LIMITED ACCESS ISSUE </p>
      </div>
      <p> To see data please contact your admin to access Twin Builder </p>
    </div>
  );
};
